import { type ApolloError, useSubscription } from '@apollo/client'
import { useState } from 'react'

import { useUser } from '@/client/context/user'
import { useIsPageVisible } from '@/client/hooks'
import { USER_UNREAD_CONVERSATIONS_SUBSCRIPTION } from '@/client/services/hasura'
import type {
  UserUnreadConversationsSubscription,
  UserUnreadConversationsSubscriptionVariables,
} from '@/client/services/hasura/generated/graphql'

export default function useCountUnreadConversations({ skip = false }: { skip?: boolean }): {
  loading: boolean
  error: ApolloError | null
  unreadConversationCount: number
} {
  const user = useUser()
  const isPageVisible = useIsPageVisible()

  const [unreadConversationCount, setUnreadConversationCount] = useState(0)

  const { loading, error = null } = useSubscription<
    UserUnreadConversationsSubscription,
    UserUnreadConversationsSubscriptionVariables
  >(USER_UNREAD_CONVERSATIONS_SUBSCRIPTION, {
    skip: !isPageVisible || skip,
    variables: {
      userId: user.id,
    },
    onData: newData => {
      const userFragment = newData.data?.data?.user_by_pk
      setUnreadConversationCount(userFragment?.unread_conversation_count ?? 0)
    },
  })

  return {
    loading,
    error,
    unreadConversationCount,
  }
}
